import React, {useRef, useState} from 'react';
import Button from "../../../../../components/button/button.jsx";
import {FaTimes} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";
import {Modal} from "../../../../../components/modal/modal.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const PlaceImage = ({state, setState}) => {
    const imgRef = useRef();
    const triggerInput = () => imgRef.current?.click();
    const [open, setOpen] = useState(false);
    const [imgScr, setImgScr] = useState(undefined);

    const attachUserImage = ({target: {files}}) => {
        const file = files[0];
        const reader = new FileReader();

        if (file.size >= 2000000) {
            let message = 'Tamanho máximo de arquivo excedido. Limite: 2MB.';
            projectUtils.swalErrorMessage('', message, 'Ok');
            return;
        }

        reader.onload = function (e) {
            setImgScr(e.target.result);
        }

        reader.readAsDataURL(file);
        setState(prev => ({...prev, attach: file, attach_id: null}));
    }

    const removeFile = (event) => {
        event.stopPropagation();
        setImgScr(null);
        setState(prev => ({...prev, attach_id: null, attach: null}));
    }

    const openModal = ({target}) => {
        if ((!state.attach_id && !imgScr) || target.classList.contains("btn-danger") || target.classList.contains("fa-close")) return;
        setOpen(true);
    }

    return (
        <>
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                    <div className="relative">
                        <div className="overflow-hidden h-[158px] bg-center bg-no-repeat bg-contain cursor-pointer border border-[#e0e0e0] rounded p-1" id="image-user" onClick={openModal}
                             style={{
                                 backgroundImage: `url(${(state.attach_id) ? API_KEEPER + "/ged/attach/" + state.attach_id : imgScr})`,
                             }}
                        >
                            {
                                (state.attach_id || imgScr) &&
                                <Button target={"danger"} className={"absolute !w-[25px] !h-[25px] !p-0 right-[5px] top-[5px]"} onClick={(e) => removeFile(e)} title="Remover imagem">
                                    <FaTimes />
                                </Button>
                            }
                        </div>
                        <input type="hidden" name="attach_id" value={""}/>
                        <input type="file" accept="image/png, image/jpeg" className="hidden" name="image" onChange={attachUserImage}
                               ref={imgRef}/>
                        <Button className={"w-full"} onClick={triggerInput}>
                            <span>Selecionar foto</span>
                        </Button>
                        <small>* Tamanho máximo 2MB</small>
                    </div>
                </div>
            </div>

            <Modal open={open} setOpen={() => setOpen(false)} onClick={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false}>
                <Modal.Body className="p-2">
                    <div style={{
                        background: `url(${(state.attach_id) ? API_KEEPER + "/ged/attach/" + state.attach_id : imgScr}) center center / contain no-repeat`,
                        height: "741px"
                    }}
                    ></div>
                </Modal.Body>
            </Modal>
        </>

    );
};

export default PlaceImage;